export * from "./deviceDetails";
export * from "./deviceDetails.mock";
export * from "./deviceDetails.types";
